/**
 * Change styles to tab buttons.
 */
 function tarjet_tab_locations(){
    const tabs = document.querySelectorAll('[data-role="tab-location"]'),
    tabContents = document.querySelectorAll(".tab-location");

    tabs.forEach((tab) => {
        tab.addEventListener("click", () => {
            const target = document.querySelector(tab.dataset.target);

            tabContents.forEach((tc) => {
            tc.classList.remove("is-active");
            });
            target.classList.add("is-active");

            tabs.forEach((t) => {
            t.classList.remove("is-active");
            });
            tab.classList.add("is-active");
        });
    });
}

tarjet_tab_locations();

export default tarjet_tab_locations;